// utils/philippines.js
import {
  provinces,
  getCityMunByProvince,
  city_mun,
  getBarangayByMun
} from 'phil-reg-prov-mun-brgy';

// Get all provinces
export const getAllProvinces = () => {
  return provinces.map(province => ({
    value: province.name,
    label: province.name,
    code: province.reg_code
  })).sort((a, b) => a.value.localeCompare(b.value));
};

// Get municipalities by province name
export const getMunicipalitiesByProvince = (provinceName) => {
  const prov = provinces.find(x => x.name === provinceName);
  if (prov) {
    return getCityMunByProvince(prov.prov_code).map(municipality => ({
      value: municipality.name,
      label: municipality.name,
      code: municipality.mun_code
    })).sort((a, b) => a.value.localeCompare(b.value));
  }
  return [];
};

// Get barangays by municipality and province
export const getBarangaysByMunicipality = (name) => {
  const mun = city_mun.find(x => x.name === name);
  if (mun) {
    return getBarangayByMun(mun.mun_code).map(barangay => ({
      value: barangay.name,
      label: barangay.name,
      code: barangay.mun_code
    })).sort((a, b) => a.value.localeCompare(b.value));
  }
  return [];
};
